"use client"
import { useSyncStore } from "@/app/(store)/sync.store"
import { cn } from "@/lib/utils"
import { MenuItem } from "@mantine/core"
import { IconCircleFilled } from "@tabler/icons-react"
import { useState, useEffect } from "react"

export function MenuItemChangeAvailabilityButton() {
  const isCheckedIn = useSyncStore(
    (state) => state.userStatus?.checkedIn ?? false
  )
  const [userStatus, setUserStatus] = useState<
    "checked-in" | "checked-out" | "unknown"
  >("unknown")

  useEffect(() => {
    if (isCheckedIn) {
      setUserStatus("checked-in")
    } else {
      setUserStatus("checked-out")
    }
  }, [isCheckedIn])

  return (
    <MenuItem
      leftSection={
        <IconCircleFilled
          className={cn(
            "size-4",
            userStatus === "checked-in"
              ? "text-green-500"
              : userStatus === "checked-out"
                ? "text-yellow-500"
                : "text-gray-500"
          )}
        />
      }
    >
      Set yourself as{" "}
      <span className="font-medium">
        {userStatus !== "checked-in" ? "Available" : "Away"}
      </span>
    </MenuItem>
  )
}
